export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ResourceList.vue?vue&type=template&id=451be36e&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ResourceList.vue?vue&type=template&id=451be36e&scoped=true&
// module id = 220
// module chunks = 0